/* Estado real do servidor, consultado uma vez e compartilhado por quem precisar
   (a moldura e a Visão Geral), para não haver duas consultas em paralelo. */
import { useSyncExternalStore } from 'react';
import type { HealthResponse } from '@jarvis/shared';
import { fetchHealth } from './api';

export type ApiStatus =
  | { state: 'checking' }
  | { state: 'up'; health: HealthResponse }
  | { state: 'down' };

let status: ApiStatus = { state: 'checking' };
const listeners = new Set<() => void>();
let started = false;

function check() {
  fetchHealth().then(
    (health) => { status = { state: 'up', health }; listeners.forEach((l) => l()); },
    () => { status = { state: 'down' }; listeners.forEach((l) => l()); }
  );
}

function subscribe(l: () => void) {
  listeners.add(l);
  if (!started) {
    started = true;
    check();
    window.setInterval(check, 30_000);
    window.addEventListener('focus', check);
  }
  return () => { listeners.delete(l); };
}

export function useApiStatus(): ApiStatus {
  return useSyncExternalStore(subscribe, () => status);
}

export function connections(s: ApiStatus) {
  const c = s.state === 'up' ? s.health.connections : null;
  return {
    banco: Boolean(c?.database),
    login: Boolean(c?.auth),
    ia: Boolean(c?.ai),
    google: Boolean(c?.google)
  };
}
